import { render, staticRenderFns } from "./ShiftBackdrop.vue?vue&type=template&id=a7780f4c&"
import script from "./ShiftBackdrop.vue?vue&type=script&lang=js&"
export * from "./ShiftBackdrop.vue?vue&type=script&lang=js&"
import style0 from "./ShiftBackdrop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports